import {Button, Divider, Grid, Typography} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import {
  messageType,
  validateAccident,
  validateCriticalIllness,
  validateCancer,
  validateDisability,
  validateIWL,
  validateShop,
} from 'ApplicationEntry/components/WorkFlow/ValidateApplication';
import {
  ValidateGroupIWL,
  validateGrpAccident,
  validateGrpCriiticalIllness,
  validateGrpGLTerm,
  validateGrpShop,
  validateGrpUL,
} from 'ApplicationEntry/components/WorkFlow/ValidateGroupApplication';
import {validateAUE} from 'ApplicationEntry/ducks/messages';
import {isLoaded, isLoading as isLoadingAUEErrorMessages} from 'ApplicationEntry/models/AUEErrorMessages';
import {
  isLoaded as isLoadedLife70ErrorMessages,
  isLoading as isLoadingLife70ErrorMessages,
} from 'ApplicationEntry/models/Life70ErrorMessages';
import {InvalidModalApplication, ValidModalApplication} from 'ApplicationEntry/models/ModalApplication';
import {matchAccidentByType} from 'ApplicationEntry/models/ProductsRiders/Accident/Accident';
import {matchCriticalIllnessByType} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/CriticalIllness';
import {ProductRiderGroups, ProductsRidersPolicyType} from 'ApplicationEntry/models/ProductsRiders/Families';
import {matchGLTERMByType} from 'ApplicationEntry/models/ProductsRiders/GLTERM/GLTERM';
import {matchIWLByType} from 'ApplicationEntry/models/ProductsRiders/IWL/IWL';
import {matchShopByType} from 'ApplicationEntry/models/ProductsRiders/Shop/Shop';
import {matchULByType} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/UniversalLife';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import Loading from 'Shared/components/Loading';
import './MessagesSection.sass';
import './WorkFlow.sass';

type MessagesSectionProps = {
  modalApplication: InvalidModalApplication | ValidModalApplication;
  isQuality: boolean;
};

const MessagesSection = ({modalApplication, isQuality}: MessagesSectionProps) => {
  const dispatch = useDispatch();
  const [validateData, setValidateData] = useState(false);
  const [enableAUE, setEnableAUE] = useState(false);
  const [validationMessages, setValidationMessages] = useState<messageType[]>([]);
  const {application} = modalApplication;

  const handleValidation = () => {
    if (enableAUE) {
      setEnableAUE(false);
    }
    setValidateData(true);
    const messages: messageType[] = [];
    const productList =
      application.caseDetails.productType.key === 'LoadedPolicyTypes'
        ? application.caseDetails.productType.selectedPolicyTypes
        : [];

    if (Object.keys(productList[0]).length > 0) {
      productList.forEach(item => {
        if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Accident]) {
          let accidentMessages: messageType[];
          accidentMessages = matchAccidentByType({
            Ordinary: ordApp =>
              validateAccident(
                ordApp,
                application.billingAgent,
                application.dependentLists,
                application.agentList,
                application.applicantDemographics,
                application.caseDetails,
                application.primaryBeneficiaryList,
                application.contingentBeneficiaryList,
                isQuality,
                application.ownerInfo
              ),
            Group: grpApp =>
              validateGrpAccident(
                grpApp,
                application.dependentLists,
                application.billingAgent,
                application.agentList,
                application.applicantDemographics,
                application.primaryBeneficiaryList,
                application.contingentBeneficiaryList,
                application.planCodes,
                application.caseDetails,
                application.uwQuestions,
                application.ownerInfo,
                isQuality
              ),
            NewYork: () => [],
          })(application.accident);
          messages.push(...accidentMessages);
        } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Cancer]) {
          const cancerMessages: messageType[] = validateCancer(
            application.cancer,
            application.billingAgent,
            application.dependentLists,
            application.premium,
            application.uwQuestions,
            isQuality,
            application.agentList,
            application.applicantDemographics,
            application.caseDetails,
            application.primaryBeneficiaryList,
            application.contingentBeneficiaryList,
            application.ownerInfo,
            application.planCodes
          );
          messages.push(...cancerMessages);
        } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Iwl]) {
          let iwlMessages: messageType[];
          iwlMessages = matchIWLByType({
            Ordinary: ordApp =>
              validateIWL(
                ordApp,
                application.dependentLists,
                application.billingAgent,
                application.applicantDemographics,
                application.agentList,
                application.uwQuestions,
                application.caseDetails,
                application.primaryBeneficiaryList,
                application.contingentBeneficiaryList,
                application.ownerInfo,
                isQuality,
                application.planCodes
              ),
            Group: () => [],
            NewYork: () => [],
          })(application.iwl);

          messages.push(...iwlMessages);
        } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness]) {
          let CIMessages: messageType[];
          CIMessages = matchCriticalIllnessByType({
            Ordinary: ordApp =>
              validateCriticalIllness(
                ordApp,
                application.dependentLists,
                application.billingAgent,
                application.applicantDemographics,
                application.agentList,
                application.uwQuestions,
                application.caseDetails,
                application.primaryBeneficiaryList,
                application.contingentBeneficiaryList,
                application.ownerInfo,
                isQuality,
                application.planCodes
              ),
            Group: grpApp =>
              validateGrpCriiticalIllness(
                grpApp,
                application.dependentLists,
                application.billingAgent,
                application.applicantDemographics,
                application.agentList,
                application.uwQuestions,
                application.planCodes,
                application.caseDetails,
                isQuality
              ),
            NewYork: () => [],
          })(application.criticalIllness);
          messages.push(...CIMessages);
        } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Disability]) {
          const DisabilityMessages: messageType[] = validateDisability(
            application.disability,
            application.dependentLists,
            application.billingAgent,
            isQuality,
            application.premium,
            application.agentList,
            application.applicantDemographics,
            application.caseDetails,
            application.primaryBeneficiaryList,
            application.contingentBeneficiaryList,
            application.uwQuestions,
            application.ownerInfo,
            application.planCodes
          );
          messages.push(...DisabilityMessages);
        } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Shop]) {
          let shopMessages: messageType[];
          shopMessages = matchShopByType({
            Ordinary: ordApp =>
              validateShop(
                ordApp,
                application.dependentLists,
                application.billingAgent,
                isQuality,
                application.premium,
                application.agentList,
                application.applicantDemographics,
                application.caseDetails,
                application.primaryBeneficiaryList,
                application.contingentBeneficiaryList,
                application.ownerInfo,
                application.planCodes
              ),
            Group: grpApp =>
              validateGrpShop(
                grpApp,
                application.dependentLists,
                application.billingAgent,
                isQuality,
                application.premium,
                application.agentList,
                application.applicantDemographics,
                application.caseDetails,
                application.primaryBeneficiaryList,
                application.contingentBeneficiaryList,
                application.uwQuestions,
                application.ownerInfo,
                application.planCodes
              ),
            NewYork: () => [],
          })(application.shop);
          messages.push(...shopMessages);
        } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.GLTerm]) {
          let glTermMessages: messageType[];
          glTermMessages = matchGLTERMByType({
            Ordinary: () => [],
            Group: grpApp =>
              validateGrpGLTerm(
                grpApp,
                application.dependentLists,
                application.billingAgent,
                application.applicantDemographics,
                application.agentList,
                application.uwQuestions,
                application.planCodes,
                application.caseDetails,
                application.ownerInfo,
                isQuality
              ),
            NewYork: () => [],
          })(application.glterm);
          messages.push(...glTermMessages);
        } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.UniversalLife]) {
          let grpULMessages: messageType[];
          grpULMessages = matchULByType({
            Ordinary: () => [],
            Group: grpApp =>
              validateGrpUL(
                grpApp,
                application.dependentLists,
                application.billingAgent,
                application.applicantDemographics,
                application.agentList,
                application.uwQuestions,
                application.planCodes,
                application.caseDetails,
                application.ownerInfo,
                isQuality
              ),
            NewYork: () => [],
          })(application.universalLife);
          messages.push(...grpULMessages);
        } else if (item.productGroup!.toUpperCase() === ProductRiderGroups[ProductsRidersPolicyType.Gwl]) {
          let gwlMessages: messageType[];
          gwlMessages = matchIWLByType({
            Ordinary: () => [],
            Group: grpApp =>
              ValidateGroupIWL(
                grpApp,
                application.dependentLists,
                application.billingAgent,
                application.applicantDemographics,
                application.agentList,
                application.uwQuestions,
                application.planCodes,
                application.caseDetails,
                application.ownerInfo,
                isQuality
              ),
            NewYork: () => [],
          })(application.iwl);
          messages.push(...gwlMessages);
        }
      });

      if (messages.length === 0) {
        setEnableAUE(true);
      }
      setValidationMessages(messages);
    }
  };

  const displayL70Message = (message: object, index: number) => {
    let policyNumber: string = message && message['classifications'] ? message['classifications'].policy_number : '';
    if (policyNumber?.length == 7) {
      policyNumber =
        message['classifications'].company_code +
        message['classifications'].policy_number +
        message['classifications'].product_code;
    }

    let messageType;

    if (message['responseSeverity'] === 'WARNING') {
      messageType = 'warning';
    } else if (message['responseSeverity'] === 'ERROR') {
      messageType = 'error';
    } else {
      messageType = 'info';
    }

    if ('life_70_audit_severity' in message['classifications']) {
      if (
        message['classifications']['life_70_audit_severity'] === 'Severity 1' ||
        message['classifications']['life_70_audit_severity'] === 'Severity 2'
      ) {
        messageType = 'warning';
      } else if (message['classifications']['life_70_audit_severity'] === '3') {
        messageType = 'error';
      }
    }

    return (
      <div className="alertmessage" key={`life-70-error-message-${index}`}>
        <div className={`alertmessage__type-${messageType}`}>
          <p className="message">{policyNumber}</p>
          <p className="message">Category: {message['category']}</p>
          {'life_70_code' in message['classifications'] && (
            <p className="message">Code: {message['classifications']['life_70_code']}</p>
          )}
          {'life_70_audit_severity' in message['classifications'] && (
            <p className="message">
              Severity: {message['classifications']['life_70_audit_severity']?.replace('Severity ', '')}
            </p>
          )}
          <p className="message">Message: {message['message']}</p>
        </div>
      </div>
    );
  };

  return (
    <form noValidate autoComplete="off" className="message-section">
      <div className="message-section__title-container">
        <Typography variant="subtitle1" className="message-section__title-container-title">
          Validate Form Data prior to Underwriting Engine
        </Typography>
      </div>

      {validateData && validationMessages.length > 0 ? (
        <div className="message-section-messages">
          <Grid container spacing={4} className="message-section-messages-wizard">
            <p>Message wizard: </p>

            <span className="dot-error" />
            <p>Error, cannot proceed with verify</p>
            <span className="dot-warning" />
            <p>Warning</p>
            <span className="dot-info" />
            <p>Message</p>
          </Grid>
          <Divider className="message-section__actions-divider" />
          <Grid container spacing={4}>
            {validationMessages.map((message, index) => (
              <>
                <Grid item xs={12} md={6}>
                  <div className="alertmessage" key={`validation-error-message-${index}`}>
                    <div className={`alertmessage__type-${message.type}`}>
                      <p className="message">{message.value}</p>
                    </div>
                  </div>
                </Grid>
              </>
            ))}
          </Grid>
          <Divider className="message-section__actions-divider" />
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <p>Proceed with L70 Verification ?</p>
            </Grid>
            <Grid item xs={12} md={3}>
              <Button
                variant="contained"
                className="application-wizard__next-step-button message-section-button"
                onClick={() => setEnableAUE(true)}
                disabled={validationMessages.some(message => message.type === 'error')}
              >
                Yes
              </Button>
            </Grid>
          </Grid>
        </div>
      ) : validateData && validationMessages.length === 0 ? (
        <Alert severity="success">No errors found.</Alert>
      ) : (
        <Alert severity="info">
          Click the "Verify" button below to validate the form data prior to Underwriting Engine.
        </Alert>
      )}
      <Divider className="application-form__actions-divider" />
      <div>
        <Button variant="contained" className="application-wizard__next-step-button" onClick={() => handleValidation()}>
          Verify
        </Button>
      </div>

      <div className="message-section__title-container">
        <Typography variant="subtitle1" className="message-section__title-container-title">
          AUE Error message
        </Typography>
      </div>

      <div className="message-section-messages">
        <Grid container spacing={4}>
          {isLoaded(application.messages.aueErrorMessage)
            ? application.messages.aueErrorMessage?.Data.map((message, index) => (
                <>
                  <Grid item xs={12} md={6}>
                    <div className="alertmessage" key={`aue-error-message-${index}`}>
                      <div
                        className={`alertmessage__type-${
                          message['classifications']['aue_code'] === 'success' ||
                          message['classifications']['aue_code'] === '1000'
                            ? 'info'
                            : 'error'
                        }`}
                      >
                        <p className="message">
                          {message && message['classifications']
                            ? message['classifications']!.company_code +
                              message['classifications']!.policy_number +
                              message['classifications']!.product_code
                            : message}
                        </p>

                        <p className="message">Category: {message['category']}</p>

                        {'aue_code' in message['classifications'] && (
                          <p className="message">Code: {message['classifications']['aue_code']}</p>
                        )}
                        <p className="message">Message: {message['message']}</p>
                      </div>
                    </div>
                  </Grid>
                </>
              ))
            : null}
          {isLoadingAUEErrorMessages(application.messages.aueErrorMessage) ? <Loading /> : null}
        </Grid>
      </div>

      <div className="message-section__title-container">
        <Typography variant="subtitle1" className="message-section__title-container-title">
          Life 70 Error messages
        </Typography>
      </div>

      <div className="message-section-messages">
        <Grid container spacing={4}>
          {isLoadedLife70ErrorMessages(application.messages.life70ErrorMessage)
            ? application.messages.life70ErrorMessage.Data.map((message, index) => (
                <>
                  {message['message'].includes('Policy Number:') ? (
                    <Grid item xs={12}>
                      {displayL70Message(message, index)}
                    </Grid>
                  ) : (
                    <Grid item xs={12} md={6}>
                      {displayL70Message(message, index)}
                    </Grid>
                  )}
                </>
              ))
            : null}
          {isLoadingLife70ErrorMessages(application.messages.life70ErrorMessage) ? <Loading /> : null}
        </Grid>
      </div>
      <Divider className="application-form__actions-divider" />
      <div>
        <Button
          variant="contained"
          className="application-wizard__next-step-button"
          onClick={() => dispatch(validateAUE(modalApplication as ValidModalApplication))}
          disabled={isQuality || !enableAUE}
        >
          Validate AUE
        </Button>
      </div>
    </form>
  );
};

export default MessagesSection;
